import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Alert, CircularProgress } from '@mui/material';
import { fetchAuthSession } from 'aws-amplify/auth';
import { getCompanies } from '../../utils/clientUtils';
import CompanyTreePicker from '../../components/CompanyTreePicker';

const ALLOWED_GROUPS = ['user_management', 'device_management', 'image_management'];

export default function Companies() {
    const { t } = useTranslation();
    const [hasAccess, setHasAccess] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchAuthSession().then(session => {
            const groups = session.tokens?.idToken?.payload?.['cognito:groups'] ?? [];
            const allowed = ALLOWED_GROUPS.some(g => groups.includes(g));
            setHasAccess(allowed);
            if (allowed) {
                setLoading(true);
                getCompanies().then(data => {
                    setCompanies(Array.isArray(data) ? data : []);
                    setLoading(false);
                });
            }
        });
    }, []);

    return (
        <Box>
            <Typography variant='h2' sx={{ color: 'primary.main', textAlign: 'left' }}>{t('companies.title')}</Typography>

            {hasAccess === null && <CircularProgress sx={{ mt: 2 }} />}

            {hasAccess === false && (
                <Alert severity="warning" sx={{ mt: 2 }}>{t('companies.noPermission')}</Alert>
            )}

            {hasAccess === true && loading && <CircularProgress sx={{ mt: 2 }} />}

            {hasAccess === true && !loading && (
                <Box sx={{ mt: 2, maxWidth: 600 }}>
                    <CompanyTreePicker companies={companies} readOnly />
                </Box>
            )}
        </Box>
    );
}
